const dashboardUrls = {
  1: `/admin/dashboard`,
  2: `/dealer/dashboard`,
  3: `/employee/dashboard`,
};

export default dashboardUrls;
